import classNames from 'classnames';
import type { ComponentProps } from 'react';

import Button from '../../../common/button/button';
import styles from './payment-button.module.scss';

const PaymentButton = ({
  className,
  ...props
}: ComponentProps<typeof Button>) => (
  <Button
    className={classNames(styles.container, className)}
    variant="secondary"
    {...props}
  />
);

export default PaymentButton;
